import { AmplifyPost } from "@sunrun/sales-experience-shared/amplify-api-wrapper";
import { logger } from "providers/logger";

const BILLS_INTERVALS_UNAVAILABLE_MESSAGE =
  "Bills & intervals not available. Please check that the customer is connected to the utility.";

const logUnlessBillsIntervalsUnavailable = (
  value: string | Error,
  context?: { error?: Error }
) => {
  if (
    JSON.stringify({ value, context }).includes(
      BILLS_INTERVALS_UNAVAILABLE_MESSAGE
    )
  ) {
    return;
  }
  logger.error(value, context);
};

const getUtilityConnectionStatus = async (jwt: string, prospectId: string) => {
  return await AmplifyPost<{ statuses: { overallStatus: string }[] }>(
    "Get Utility Connection Status",
    "OfferExpApi",
    `/prospect/${prospectId}/utility-connection-status`,
    {
      headers: {
        Authorization: `Bearer ${jwt}`,
      },
    },
    {
      ...logger,
      error: (value, context) =>
        logUnlessBillsIntervalsUnavailable(value, context),
    } as typeof logger
  );
};

export { getUtilityConnectionStatus };
